//if (console === undefined) {
//    var console = {};
//}

//Global namespace
var sverigefolkhogskolor = {
    //rollerTimeout: 0
};

$(document).ready(function () {
    SideBar.init();
    var platform = window.navigator.platform,
        macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
        iosPlatforms = ['iPhone', 'iPad', 'iPod'];
    if (macosPlatforms.indexOf(platform) !== -1 || iosPlatforms.indexOf(platform) !== -1) {
        $('.adjustfont').css('padding-top', '8px');
        $('.adjustfont').css('padding-bottom', '4px');
        $('.display-more-ipad').css('margin-top', '8px');
    } 
    // console.log(document);
    // console.log(document.body);
    // console.log(document.body.parent);
    document.body.parentNode.className = document.body.parentNode.className.replace("no-js", "js");
    CounterUp.init();
    InitLoadEvents.init();
});